(function injectConfirmStyles() {
  if (document.getElementById('cart-remove-confirm-styles')) return;
  const style = document.createElement('style');
  style.id = 'cart-remove-confirm-styles';
  style.textContent = `
    .cart-remove-confirm {
      position: fixed;
      z-index: 9999;
      background: #1a1020;
      border: 1px solid rgba(240,226,208,0.25);
      border-radius: 8px;
      padding: 8px 10px;
      display: flex;
      align-items: center;
      gap: 6px;
      white-space: nowrap;
      box-shadow: 0 4px 20px rgba(0,0,0,0.45);
      animation: confirm-pop 0.15s ease;
      font-family: 'Josefin Sans', sans-serif;
    }
    .cart-remove-confirm::after {
      content: '';
      position: absolute;
      top: 100%;
      right: 10px;
      left: auto;
      border: 5px solid transparent;
      border-top-color: #1a1020;
    }
    @keyframes confirm-pop {
      from { opacity: 0; transform: translateY(4px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .cart-remove-confirm__text {
      font-size: 1.2rem;
      color: #f0e2d0;
    }
    .cart-remove-confirm__yes,
    .cart-remove-confirm__no {
      font-size: 1.1rem;
      font-family: 'Josefin Sans', sans-serif;
      border: none;
      border-radius: 4px;
      padding: 4px 9px;
      cursor: pointer;
      font-weight: 600;
      letter-spacing: 0.03em;
      line-height: 1;
    }
    .cart-remove-confirm__yes {
      background: #c0392b;
      color: #fff;
    }
    .cart-remove-confirm__yes:hover { background: #e74c3c; }
    .cart-remove-confirm__no {
      background: rgba(240,226,208,0.15);
      color: #f0e2d0;
    }
    .cart-remove-confirm__no:hover { background: rgba(240,226,208,0.28); }
  `;
  document.head.appendChild(style);
})();

function showRemoveConfirm(anchorEl, onConfirm) {
  document.querySelectorAll('.cart-remove-confirm').forEach(el => el.remove());

  const bubble = document.createElement('div');
  bubble.className = 'cart-remove-confirm';
  bubble.innerHTML = `
    <span class="cart-remove-confirm__text">Remove item?</span>
    <button class="cart-remove-confirm__yes" type="button">Remove</button>
    <button class="cart-remove-confirm__no" type="button">Keep</button>
  `;

  // Mount on body so it's never inside a button (avoids capture-listener re-trigger)
  document.body.appendChild(bubble);

  // Position above the anchor. Bubble is position:fixed so coords are
  // viewport-relative. Clamp horizontally so it stays on-screen when the
  // anchor button sits near the left edge on mobile.
  const place = () => {
    const rect = anchorEl.getBoundingClientRect();
    const vw = document.documentElement.clientWidth;
    const margin = 8;
    bubble.style.top = (rect.top - bubble.offsetHeight - margin) + 'px';
    bubble.style.right = 'auto';
    const bw = bubble.offsetWidth;
    // Prefer right-aligning to the button; clamp within viewport.
    let left = rect.right - bw;
    if (left < margin) left = margin;
    if (left + bw > vw - margin) left = vw - margin - bw;
    bubble.style.left = left + 'px';
  };
  place();
  requestAnimationFrame(place);

  const dismiss = () => bubble.remove();

  bubble.querySelector('.cart-remove-confirm__yes').addEventListener('click', (e) => {
    e.stopPropagation();
    dismiss();
    onConfirm();
  });

  bubble.querySelector('.cart-remove-confirm__no').addEventListener('click', (e) => {
    e.stopPropagation();
    dismiss();
  });

  setTimeout(() => {
    document.addEventListener('click', dismiss, { once: true });
  }, 0);
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const cartItems = this.closest('cart-items');
      showRemoveConfirm(this, () => {
        cartItems.updateQuantity(this.dataset.index, 0);
      });
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    // Intercept minus click when quantity is 1 (would remove the item)
    this.addEventListener('click', (event) => {
      const btn = event.target.closest('.quantity__button[name="minus"]');
      if (!btn) return;
      const input = btn.closest('quantity-input')?.querySelector('input');
      if (!input || parseInt(input.value) > 1) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const cartItems = this;
      showRemoveConfirm(btn.closest('.product-quantity') || btn, () => {
        cartItems.updateQuantity(input.dataset.index, 0);
      });
    }, true); // capture phase to intercept before QuantityInput
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  makeCartLineRef() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return `copy-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  }

  pairedLinesForSource(cart, source, line) {
    const props = source?.properties || {};
    const orderId = props._OrderID || props.OrderID;
    // Before a quantity increase has migrated a legacy print, cart controls
    // use its stable current Shopify line key as the copy reference.
    const lineRef = props._cart_line_ref || source.key;
    if (!orderId) return [];

    const exact = (cart.items || []).filter((item) => {
      return item.properties?._paired_with_line_ref === lineRef;
    });
    if (exact.length) return exact;

    // Legacy carts only knew the shared design OrderID. Consistent with the
    // cart-row Liquid fallback, the first print copy owns those old unscoped
    // add-ons; later copies must not all claim the same charged line.
    const earlierMatchingPrint = (cart.items || []).slice(0, Math.max(0, Number(line) - 1)).some((item) => {
      const itemProps = item.properties || {};
      return (itemProps._OrderID || itemProps.OrderID) === orderId;
    });
    if (earlierMatchingPrint) return [];

    return (cart.items || []).filter((item) => {
      const itemProps = item.properties || {};
      return itemProps._paired_with_order_id === orderId && !itemProps._paired_with_line_ref;
    });
  }

  cartMutation(url, body) {
    return fetch(url, {
      ...fetchConfig('json'),
      body: JSON.stringify(body)
    }).then((response) => {
      if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
      return response.json();
    });
  }

  duplicatePersonalizedCopies(line, requestedQuantity, sections) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        const source = cart.items?.[Number(line) - 1];
        const sourceProps = { ...(source?.properties || {}) };
        const orderId = sourceProps._OrderID || sourceProps.OrderID;
        if (!source || !orderId) throw new Error('Personalised cart line was not found');

        const pairedLines = this.pairedLinesForSource(cart, source, line);
        const sourceRef = sourceProps._cart_line_ref || this.makeCartLineRef();
        sourceProps._cart_line_ref = sourceRef;

        // A grouped quantity cannot have independently removable wrapping.
        // Normalize the original to one copy, then add each requested copy as
        // its own line with its own relationship id and paid add-on line(s).
        let chain = Promise.resolve();
        if (source.quantity !== 1 || source.properties?._cart_line_ref !== sourceRef) {
          chain = chain.then(() => this.cartMutation(theme.routes.cart_change_url, {
            id: source.key,
            quantity: 1,
            properties: sourceProps
          }));
        }

        pairedLines.forEach((paired) => {
          const pairedProps = {
            ...(paired.properties || {}),
            _paired_with_order_id: orderId,
            _paired_with_line_ref: sourceRef
          };
          chain = chain.then(() => this.cartMutation(theme.routes.cart_change_url, {
            id: paired.key,
            quantity: 1,
            properties: pairedProps
          }));
        });

        const itemsToAdd = [];
        const copiesToAdd = Math.max(0, Number(requestedQuantity) - 1);
        for (let copy = 0; copy < copiesToAdd; copy += 1) {
          const copyRef = this.makeCartLineRef();
          const printItem = {
            id: source.variant_id,
            quantity: 1,
            properties: { ...sourceProps, _cart_line_ref: copyRef }
          };
          const sellingPlanId = source.selling_plan_allocation?.selling_plan?.id;
          if (sellingPlanId) printItem.selling_plan = sellingPlanId;
          itemsToAdd.push(printItem);

          pairedLines.forEach((paired) => {
            itemsToAdd.push({
              id: paired.variant_id,
              quantity: 1,
              properties: {
                ...(paired.properties || {}),
                _paired_with_order_id: orderId,
                _paired_with_line_ref: copyRef
              }
            });
          });
        }

        return chain
          .then(() => this.cartMutation(theme.routes.cart_add_url || '/cart/add.js', {
            items: itemsToAdd,
            sections,
            sections_url: window.location.pathname
          }))
          .then((addState) => fetch('/cart.js', { credentials: 'same-origin' })
            .then((response) => response.json())
            .then((freshCart) => {
              freshCart.sections = addState.sections || {};
              return freshCart;
            }));
      });
  }

  // Bring each paired add-on down to `keepFor(currentQuantity)` units.
  //
  // Two things make this fiddly. Line keys are re-hashed after a cart mutation,
  // so a chain built from one snapshot silently no-ops on every key after the
  // first — hence the re-read and property-based match before each change.
  // And Shopify splits a multi-quantity personalised print into separate lines
  // that SHARE one _cart_line_ref, so "remove one copy" must reduce the add-on
  // by the units actually going away rather than zeroing the whole line.
  adjustPairedLines(pairedLines, sourceKey, keepFor) {
    const targets = pairedLines.map((paired) => ({
      variantId: paired.variant_id,
      lineRef: paired.properties?._paired_with_line_ref || null,
      orderId: paired.properties?._paired_with_order_id || null
    }));
    let chain = Promise.resolve();
    targets.forEach((target) => {
      chain = chain
        .then(() => fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json()))
        .then((freshCart) => {
          const match = (freshCart.items || []).find((item) => {
            const props = item.properties || {};
            if (item.variant_id !== target.variantId) return false;
            if (item.key === sourceKey) return false;
            return target.lineRef
              ? props._paired_with_line_ref === target.lineRef
              : (!props._paired_with_line_ref && props._paired_with_order_id === target.orderId);
          });
          if (!match) return null;
          const current = Number(match.quantity || 0);
          const keep = Math.max(0, Math.min(current, keepFor(current)));
          if (keep === current) return null;
          return this.cartMutation(theme.routes.cart_change_url, { id: match.key, quantity: keep });
        });
    });
    return chain;
  }

  // The source line's own key can also be stale by the time its add-ons are
  // gone. Re-resolve it by identity before the final mutation.
  resolveSourceKey(sourceProps, fallbackKey) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        const ref = sourceProps._cart_line_ref;
        const orderId = sourceProps._OrderID || sourceProps.OrderID;
        const match = (cart.items || []).find((item) => {
          const props = item.properties || {};
          if (item.key === fallbackKey) return true;
          if (ref) return props._cart_line_ref === ref;
          return (props._OrderID || props.OrderID) === orderId;
        });
        return match ? match.key : fallbackKey;
      })
      .catch(() => fallbackKey);
  }

  removePersonalizedCopy(line, sections) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        const source = cart.items?.[Number(line) - 1];
        if (!source) throw new Error('Personalised cart line was not found');
        const pairedLines = this.pairedLinesForSource(cart, source, line);
        const sourceProps = source.properties || {};
        // Give back exactly the units leaving with this copy — a sibling copy
        // sharing the same ref keeps its own wrap.
        const leaving = Number(source.quantity || 1);
        return this.adjustPairedLines(pairedLines, source.key, (current) => current - leaving)
          .then(() => this.resolveSourceKey(sourceProps, source.key))
          .then((sourceKey) => this.cartMutation(theme.routes.cart_change_url, {
            id: sourceKey,
            quantity: 0,
            sections,
            sections_url: window.location.pathname
          }));
      });
  }

  // Reducing a grouped personalised line (2 → 1) used to leave its paid gift
  // add-ons at the old count — invisible, because paired lines render inside
  // the print's row rather than as their own row. Trim the add-ons to the new
  // quantity first, then apply the decrease. Only ever reduces.
  reducePersonalizedCopies(line, requestedQuantity, sections) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        const source = cart.items?.[Number(line) - 1];
        if (!source) throw new Error('Personalised cart line was not found');
        const pairedLines = this.pairedLinesForSource(cart, source, line);
        const sourceProps = source.properties || {};
        // Cap the add-on at the new print count. Never increases.
        return this.adjustPairedLines(pairedLines, source.key, () => Number(requestedQuantity))
          .then(() => this.resolveSourceKey(sourceProps, source.key))
          .then((sourceKey) => this.cartMutation(theme.routes.cart_change_url, {
            id: sourceKey,
            quantity: requestedQuantity,
            sections,
            sections_url: window.location.pathname
          }));
      });
  }

  renderQuantityState(line, name, parsedState, rawState) {
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (parsedState.errors) {
      this.updateErrorLiveRegions(line, parsedState.errors);
    }
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      if (element) {
        const elementToReplace = element.querySelector(section.selector) || element;

        if (elementToReplace && parsedState.sections?.[section.section]) {
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }
      }
    }));

    this.updateQuantityLiveRegions(line, parsedState.item_count);

    const lineItem = document.getElementById(`CartItem-${line}`);
    if (lineItem && name) lineItem.querySelector(`[name="${name}"]`)?.focus();
    this.disableLoading();

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: rawState || parsedState
      }
    }));
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);

    const quantityInput = this.querySelector(`[name="updates[]"][data-index="${line}"]`);
    const isPersonalized = Boolean(quantityInput?.dataset.customOrderId);
    const renderedQuantity = Number(quantityInput?.getAttribute('value') || quantityInput?.value || 0);
    const requestedQuantity = Number(quantity);

    if (isPersonalized && requestedQuantity > renderedQuantity) {
      this.duplicatePersonalizedCopies(line, requestedQuantity, sections)
        .then((parsedState) => this.renderQuantityState(line, name, parsedState, parsedState))
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          this.disableLoading();
          if (this.cartErrors) this.cartErrors.textContent = theme.cartStrings.error;
        });
      return;
    }

    if (isPersonalized && requestedQuantity > 0 && requestedQuantity < renderedQuantity) {
      this.reducePersonalizedCopies(line, requestedQuantity, sections)
        .then((parsedState) => this.renderQuantityState(line, name, parsedState, parsedState))
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          this.disableLoading();
          if (this.cartErrors) this.cartErrors.textContent = theme.cartStrings.error;
        });
      return;
    }

    if (isPersonalized && requestedQuantity === 0) {
      this.removePersonalizedCopy(line, sections)
        .then((parsedState) => this.renderQuantityState(line, name, parsedState, parsedState))
        .catch(() => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          this.disableLoading();
          if (this.cartErrors) this.cartErrors.textContent = theme.cartStrings.error;
        });
      return;
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.renderQuantityState(line, name, parsedState, state);
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }
  
  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = theme.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

if (!customElements.get('cart-discount')) {
  customElements.define('cart-discount', class CartDiscount extends HTMLElement {
    constructor() {
      super();
      this.onApplyDiscount = this.applyDiscount.bind(this);
      this.onInputKeydown = this.handleInputKeydown.bind(this);
    }

    get sectionId() {
      return this.getAttribute('data-section-id');
    }

    connectedCallback() {
      this.submitButton = this.querySelector('[data-discount-btn]');
      this.discountInput = this.querySelector('[name="discount"]');
      this.resultsElement = this.lastElementChild;
      this.submitButton.addEventListener('click', this.onApplyDiscount);
      this.discountInput?.addEventListener('keydown', this.onInputKeydown);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.submitButton.removeEventListener('click', this.onApplyDiscount);
      this.discountInput?.removeEventListener('keydown', this.onInputKeydown);
    }

    handleInputKeydown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.applyDiscount(event);
      }
    }

    getSectionsToRender() {
      let sections = [
        {
          id: 'mini-cart',
          section: document.getElementById('mini-cart')?.id,
          selector: '.shopify-section',
        },
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items')?.dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'mobile-cart-icon-bubble',
          section: 'mobile-cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset.id,
          selector: '.js-contents',
        }
      ];
      if (document.querySelector('#main-cart-footer .free-shipping')) {
        sections.push({
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer')?.dataset.id,
          selector: '.free-shipping',
        });
      }
      return sections;
    }

    applyDiscount(event) {
      event.preventDefault();

      const discountCode = this.querySelector('[name="discount"]');
      if (!(discountCode instanceof HTMLInputElement) || typeof this.getAttribute('data-section-id') !== 'string') return;

      this.abortController?.abort();
      this.abortController = new AbortController();

      const discountCodeValue = discountCode.value.trim();
      if (discountCodeValue === '') return;

      const existingDiscounts = this.existingDiscounts();
      if (existingDiscounts.includes(discountCodeValue)) return;

      this.setDiscountError('');
      this.submitButton.setAttribute('aria-busy', 'true');

      const sections = this.getSectionsToRender().map((section) => section.section);
      const body = JSON.stringify({
        discount: [...existingDiscounts, discountCodeValue].join(','),
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig('json'), ...{ body }, signal: this.abortController.signal })
        .then((response) => response.json())
        .then((parsedState) => {
          if (
            parsedState.discount_codes.find((discount) => {
              return discount.code === discountCodeValue && discount.applicable === false;
            })
          ) {
            discountCode.value = '';
            // Check if there are automatic discounts applied - if so, show combination error
            // Check both cart-level and line-item-level automatic discounts
            const hasCartLevelAutoDiscounts = parsedState.cart_level_discount_applications?.some(
              (discount) => discount.type === 'automatic'
            );
            const hasLineItemDiscounts = parsedState.items?.some(
              (item) => item.discounts?.length > 0 || item.discount_allocations?.length > 0
            );
            // Also check if total_discount > 0 but no applicable discount codes (means automatic discount)
            const applicableCodeCount = parsedState.discount_codes?.filter(d => d.applicable).length || 0;
            const hasAutoDiscountFromTotal = parsedState.total_discount > 0 && applicableCodeCount === 0;

            if (hasCartLevelAutoDiscounts || hasLineItemDiscounts || hasAutoDiscountFromTotal) {
              this.setDiscountError(theme.discountStrings.combinationError);
            } else {
              this.setDiscountError(theme.discountStrings.error);
            }
            return;
          }

          const newHtml = parsedState.sections[this.sectionId];
          const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
          const section = parsedHtml.getElementById(`shopify-section-${this.sectionId}`);

          if (section) {
            const discountCodes = section?.querySelectorAll('button[is="discount-remove"]') || [];
            const codes = Array.from(discountCodes)
              .map((element) => (element instanceof HTMLButtonElement ? element.getAttribute('data-discount') : null))
              .filter(Boolean);

            if (
              codes.length === existingDiscounts.length &&
              codes.every((code) => existingDiscounts.includes(code)) &&
              parsedState.discount_codes.find((discount) => {
                return discount.code === discountCodeValue && discount.applicable === true;
              })
            ) {
              discountCode.value = '';
              this.setDiscountError(theme.discountStrings.shippingError);
              return;
            }
          }

          // Render the updated sections
          this.getSectionsToRender().forEach((section => {
            const element = document.getElementById(section.id);
            if (element) {
              const elementToReplace = element.querySelector(section.selector) || element;
              if (elementToReplace && parsedState.sections[section.section]) {
                elementToReplace.innerHTML = new DOMParser()
                  .parseFromString(parsedState.sections[section.section], 'text/html')
                  .querySelector(section.selector)?.innerHTML;
              }
            }
          }));

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: parsedState });
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          }
          else {
            console.error(error);
          }
        })
        .finally(() => {
          this.submitButton.removeAttribute('aria-busy');
        });
    }

    removeDiscount(event) {
      if ((event instanceof KeyboardEvent && event.key !== 'Enter') || !(event instanceof MouseEvent)) {
        return;
      }

      const discountCode = event.currentTarget.getAttribute('data-discount');

      if (!discountCode) return;

      const existingDiscounts = this.existingDiscounts();
      const index = existingDiscounts.indexOf(discountCode);
      if (index === -1) return;

      existingDiscounts.splice(index, 1);

      this.abortController?.abort();
      this.abortController = new AbortController();

      this.setDiscountError('');
      event.currentTarget.setAttribute('loading', '');

      const sections = this.getSectionsToRender().map((section) => section.section);
      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(theme.routes.cart_update_url, { ...fetchConfig(), ...{ body }, signal: this.abortController.signal })
        .then((response) => response.json())
        .then((parsedState) => {
          // Render the updated sections
          this.getSectionsToRender().forEach((section => {
            const element = document.getElementById(section.id);
            if (element) {
              const elementToReplace = element.querySelector(section.selector) || element;
              if (elementToReplace && parsedState.sections[section.section]) {
                elementToReplace.innerHTML = new DOMParser()
                  .parseFromString(parsedState.sections[section.section], 'text/html')
                  .querySelector(section.selector)?.innerHTML;
              }
            }
          }));

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discount', cart: parsedState });
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          }
          else {
            console.error(error);
          }
        })
        .finally(() => {
          event.target.removeAttribute('loading');
        });
    }

    existingDiscounts() {
      const discountCodes = [];
      const discountPills = this.querySelectorAll('button[is="discount-remove"]');
      for (const pill of discountPills) {
        if (pill.hasAttribute('data-discount')) {
          discountCodes.push(pill.getAttribute('data-discount'));
        }
      }
      return discountCodes;
    }

    setDiscountError(error) {
      this.resultsElement.lastElementChild.textContent = error;
      if(error.length === 0) {
        this.resultsElement.classList.add('hidden');
      } else {
        this.resultsElement.classList.remove('hidden');
      }
    }
  });
}

class DiscountRemove extends HTMLButtonElement {
  constructor() {
    super();
     this.addEventListener('click', (event) => {
        const cartDiscount = this.closest('cart-discount') || document.querySelector('cart-discount');
        if (cartDiscount) {
          event.preventDefault();
          cartDiscount.removeDiscount(event);
        }
      });
  }
}
customElements.define('discount-remove', DiscountRemove, { extends: 'button' });

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);
